import React, {Component} from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {withNamespaces} from "react-i18next";
import {dashboardActions} from "../../../actions/dashboard.actions";
import {connect} from 'react-redux';
import WidgetPowerManagement from "./_components/WidgetPowerManagement";
import {dashboardService} from "../../../services/dashboard.service";
import WidgetSceneDaliManagement from "./_components/WidgetSceneDaliManagement";
import WidgetDeviceGroupManagement from "./_components/WidgetDeviceGroupManagement";
import WidgetVolumeManagement from "./_components/WidgetVolumeManagement";
import WidgetPcList from "./_components/WidgetPcList";
import {widgetConstants} from "./_constants/widget-constants";
import LayoutRow from "../../../components/Layout/LayoutRow";
import LayoutColumn from "../../../components/Layout/LayoutColumn";
import {Button} from "react-bootstrap";
import WidgetExhibitionScenario from "./_components/WidgetExhibitionScenario";
import {exhibitionScenarioActions} from "../../../actions/exhibition-scenario.actions";
import {userHelper} from "../../../helpers/user-helper";
import WidgetVisit from "./_components/WidgetVisit";
import WidgetSceneDmxManagement from "./_components/WidgetSceneDmxManagement";
import {actions} from "react-redux-toastr";
import WidgetMZMAPManagement from "./_components/WidgetMZMAPManagement";
import WidgetLantick from "./_components/WidgetLantick";
import WidgetSceneDaliEsSystemManagement from "./_components/WidgetSceneDaliEsSystemManagement";
import WidgetDelayInformationPc from "./_components/WidgetDelayInformationPc";
import WidgetSensors from "./_components/WidgetSensors";
import WidgetCustomButtons from "./_components/WidgetCustomButtons";

class DashboardPage extends Component {

    state = {
        isEdit: false,
        layout: {
            rows: [
                {
                    id: 1,
                    columns: [
                        {
                            id: 1,
                            className: 7,
                            widgets: [
                                widgetConstants.WID_SCENE_DALI,
                                widgetConstants.WID_SCENE_DALI_ES_SYSTEM_DALI,
                                widgetConstants.WID_SCENE_DMX,
                                widgetConstants.WID_LANTICK,
                                widgetConstants.WID_VOLUME,
                                widgetConstants.WID_EXHIBITION_SCENARIO,
                                widgetConstants.WID_VISIT,
                            ]
                        },
                        {
                            id: 2,
                            className: 5,
                            widgets: [
                                widgetConstants.WID_POWER,
                                widgetConstants.WID_CUSTOM_BUTTONS,
                                widgetConstants.WID_DEVICE_GROUP
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    columns: [
                        {
                            id: 1,
                            className: 12,
                            widgets: [widgetConstants.WID_PC_LIST]
                        }
                    ]
                }
            ]
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(exhibitionScenarioActions.getDropdownListExhibitionScenario());
        this.updateStore();
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        if(this.interval) {
            dispatch(dashboardActions.clearDashboard());
            clearInterval(this.interval);
        }
    }

    updateStore = () => {
        const { dispatch } = this.props;
        dispatch(dashboardActions.getDashboard());

        if(!this.interval) {
            this.interval = setInterval(this.updateStore, 5000);
        }
    };

    handleActionPowerManagement = (action) => {
        dashboardService.setPowerManagement(action)
            .then(res => this.updateStore());
    };

    handleActionDaliScene = (action) => {
        dashboardService.setDaliScenes(action)
            .then(res => this.updateStore())
    };

    handleActionDaliEsSystemScene = (action) => {
        dashboardService.setDaliEsSystemScenes(action)
            .then(res =>  this.updateStore());
    }

    handleActionDmxPxmScene = (action) => {
        dashboardService.setDmxPxmScenes(action)
            .then(res => this.updateStore())
    }

    handleActionDeviceGroup = (action, type = "GET") => {
        if(type === "GET") {
            dashboardService.setDeviceGroup(action)
                .then(res => this.updateStore())
        }
        else {
            dashboardService.setPowerManagement(action)
                .then(res => this.updateStore())
        }
    };

    handleChangeVol = (model) => {
        dashboardService.changeVolume(model)
            .then(res => this.updateStore())
    };

    handleMute = (model) => {
        dashboardService.volumeControl(model)
            .then(res => this.updateStore());
    };

    handleChangeExhibitionScenario = (model) => {
        dashboardService.changeExhibitionScenario(model)
            .then(res => this.updateStore())
    }

    handleActionLantick = (model) => {
        dashboardService.setLantick(model)
            .then(res => this.updateStore());
    }

    handleCustomButton = (url, isAuthorize = false) => {
        dashboardService.getNodeRedRequest(url, isAuthorize)
            .then(res => this.updateStore())
    }

    handleActionVisits = (action) => {
        console.log(action)
    }


    selectWidgetByConst = (widgetType, idx) => {
        const { dashboard, exhibitionState, exhibitionScenarioDropdown, user } = this.props;
        const useScenario = userHelper.getUseExhibitionScenario(user);
        const useRfidInExhibitionScenario = userHelper.getUseRfidInExhibitionScenario(user);


        switch (widgetType) {
            case widgetConstants.WID_LANTICK:
                return (
                    <WidgetLantick
                        key={idx}
                        claim="dashboard.lantick"
                        lantickData={ dashboard?.deviceLantickList }
                        callbackAction={this.handleActionLantick}
                    />
                )
            case widgetConstants.WID_POWER:
                return (
                    <WidgetPowerManagement
                        key={idx}
                        claim="dashboard.power-management"
                        dashboard={ dashboard }
                        exhibitionState={ exhibitionState }
                        callbackAction={this.handleActionPowerManagement}
                    />
                );
            case widgetConstants.WID_DEVICE_GROUP:
                return (
                    dashboard?.deviceGroups.length > 0 ? (
                        <WidgetDeviceGroupManagement
                            key={idx}
                            claim="dashboard.device-group-control"
                            deviceGroups={ dashboard?.deviceGroups }
                            callbackAction={this.handleActionDeviceGroup }
                        />
                    )  : (
                        <React.Fragment key={idx}/>
                    )
                );
            case widgetConstants.WID_PC_LIST:
                return (
                    dashboard?.devicePcList.length > 0 ? (
                        <WidgetPcList key={idx} claim="dashboard.pc-list" pcList={dashboard?.devicePcList}/>
                    ) : (<React.Fragment key={idx} />)
                );
            case widgetConstants.WID_SCENE_DALI:
                return (
                    dashboard?.deviceDaliList.length > 0 ? (
                        <WidgetSceneDaliManagement
                            key={idx}
                            claim="dashboard.helvar-control"
                            daliList={ dashboard?.deviceDaliList }
                            callbackAction={this.handleActionDaliScene}
                        />
                    ) : (<React.Fragment key={idx}/>)
                );
            case widgetConstants.WID_SCENE_DALI_ES_SYSTEM_DALI:
                return (
                    dashboard?.deviceDaliEsSystemList.length > 0 ? (
                        <WidgetSceneDaliEsSystemManagement
                            key={idx}
                            claim="dashboard.es-system-control"
                            daliList={ dashboard?.deviceDaliEsSystemList }
                            callbackAction={this.handleActionDaliEsSystemScene}
                        />
                    ) : (<React.Fragment key={idx}/>)
                )
            case widgetConstants.WID_VOLUME:
                return (
                    dashboard?.deviceVolumeList.length > 0 ? (
                        <WidgetVolumeManagement
                            key={idx}
                            claim="dashboard.sound-control"
                            deviceList={ dashboard?.deviceVolumeList }
                            callbackChangeVolume={this.handleChangeVol}
                            callbackMuteAction={this.handleMute}
                        />
                    ) : (<React.Fragment  key={idx}/>)
                );
            case widgetConstants.WID_EXHIBITION_SCENARIO:
                return (
                    (dashboard?.exhibitionScenarioSettings && useScenario) ? (
                        <WidgetExhibitionScenario
                            key={idx}
                            scenarioList={dashboard?.exhibitionScenarioSettings}
                            exhibitionScenarioList={exhibitionScenarioDropdown}
                            callbackAction={this.handleChangeExhibitionScenario}
                        />
                    ) : ( (<React.Fragment  key={idx}/>))
                )
            case widgetConstants.WID_MZMAP:
                return (
                    <WidgetMZMAPManagement key={idx}/>
                )
            case widgetConstants.WID_SCENE_DMX:
                return (
                    dashboard?.devicePxmModbusList.length > 0 ? (
                        <WidgetSceneDmxManagement
                            key={idx}
                            claim="dashboard"
                            dmxList={ dashboard?.devicePxmModbusList }
                            callbackAction={this.handleActionDmxPxmScene}
                        />
                    ) : (<React.Fragment key={idx}/>)
            );
            case widgetConstants.WID_VISIT:
                return (
                    (useRfidInExhibitionScenario && useScenario) ? (
                        <WidgetVisit
                            key={idx}
                            claim="dashboard.visits"
                            visits={dashboard?.visits}
                            callbackAction={this.handleActionVisits}
                        />
                    ) : ( (<React.Fragment  key={idx}/>))
                )
            case widgetConstants.WID_CUSTOM_BUTTONS:
                return  (
                    <WidgetCustomButtons
                        key={idx}
                        callbackAction={this.handleCustomButton}
                    />
                )
            default:
                return (
                    <React.Fragment key={idx}/>
                )
        }
    };

    setEditMode = () => {
        this.setState({
            ...this.state,
            isEdit: !this.state.isEdit,
        })
    };

    addColumn = (row) => {
        row.columns.push({
            id: (row.columns.length + 1),
            className: 6,
            widgets: []
        });

        this.setState({...this.state, ...this.state.layout});
    };

    deleteColumn = (row, columnId) => {
        const index = row.columns.findIndex((item) => item.id === columnId);
        row.columns.splice(index, 1);

        this.setState({...this.state, ...this.state.layout});
    };

    changeSizeColumn = (row, columnId, size) => {
        row.columns.forEach((item) => {
            if(item.id === columnId) {
                item.className = size
            }
        });

        this.setState({...this.state, ...this.state.layout});
    };

    setWidgetFromColumn = (row, columnId, widget) => {
        row.columns.forEach((item) => {
            if(item.id === columnId) {
                item.widget = widget;
            }
        });

        this.setState({...this.state, ...this.state.layout});
    };

    render() {
        const breadcrumb = [{ value: 'dashboard', path: '#' }];
        const { dashboard, exhibitionState, exhibitionScenarioDropdown, user, t } = this.props;
        const { layout } = this.state;

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <div className="row">
                    <h4 className="col-md-6">{t('dashboard')}</h4>
                    <div className="col-md-6 text-right">
                        {/*<Button*/}
                        {/*    className="text-right"*/}
                        {/*    size={"sm"}*/}
                        {/*    variant={"outline-secondary"} onClick={() => this.setEditMode() }>*/}
                        {/*    { t('config') } <i className="fas fa-cogs" />*/}
                        {/*</Button>*/}
                    </div>
                </div>
                {/*<WidgetDelayInformationPc dashboard={dashboard} />*/}

                { layout.rows.map((row, rowIdx) => {
                    return (
                        <React.Fragment key={rowIdx}>
                            { this.state.isEdit ? (
                                <Button
                                    size={"sm"}
                                    variant={"success"}
                                    onClick={(e) => this.addColumn(row)}>
                                    Add item
                                </Button>
                            ) : (<React.Fragment/>) }

                            <LayoutRow editMode={this.state.isEdit}>
                                { row.columns.map((column, colIdx) => {
                                    return (
                                        <LayoutColumn
                                            key={colIdx}
                                            editMode={this.state.isEdit}
                                            setWidget={(id, widget) => this.setWidgetFromColumn(row, id, widget)}
                                            changeSizeColumn={(id, size) => this.changeSizeColumn(row, id, size)}
                                            deleteColumn={(id) => this.deleteColumn(row, id)}
                                            column={column}>
                                            { column.widgets.map((widget, idx) => {
                                                return this.selectWidgetByConst(widget, idx)
                                            })}

                                            { this.state.isEdit ? (

                                                <button className="btn btn-secondary text-center p-5 my-3">
                                                    Dodaj widget <i className="fas fa-plus-circle"/>
                                                </button>

                                            ) : (<React.Fragment/>) }

                                        </LayoutColumn>
                                    )
                                })}
                            </LayoutRow>
                        </React.Fragment>
                    )
                }) }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { dashboard, exhibitionState } = state.dashboardReducer;
    const { exhibitionScenarioDropdown } = state.exhibitionScenarioReducer;
    const { user } = state.authenticationReducer;
    return {
        user,
        dashboard,
        exhibitionState,
        exhibitionScenarioDropdown
    }
};

export default withNamespaces()(connect(mapStateToProps)(DashboardPage));
